// Intercept XHR to inject sort/filter params into loadmore requests
(function() {
  const originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url) {
    if (typeof url === 'string' && url.includes('loadmoreproduct')) {
      const currentParams = new URLSearchParams(window.location.search);
      currentParams.delete('page');
      if (currentParams.toString()) {
        const xhrUrl = new URL(url, window.location.origin);
        currentParams.forEach(function(value, key) {
          xhrUrl.searchParams.set(key, value);
        });
        url = xhrUrl.toString();
      }
    }
    return originalOpen.apply(this, arguments);
  };
})();